export enum ModalDialogDismissOption {
  OK = 'OK',
  CANCEL = 'CANCEL',
  CLOSE = 'CLOSE',
  BACKDROP = 0,

}
